/**
 * Default RTB frequency rules (minutes between shows).
 * day_of_week: 0 = Mon .. 6 = Sun; hour: 0..23.
 */

export function defaultMinutesForSlot(dow, hour) {
    if (dow >= 0 && dow <= 4) {
        if ((hour >= 7 && hour < 10) || hour === 13 || (hour >= 17 && hour < 21)) {
            return 3;
        }
        return 6;
    }
    if (hour >= 11 && hour < 22) {
        return 3;
    }
    return 6;
}

/**
 * @param {Array<{day?: number, startTime: number, endTime: number}>|null|undefined} campaignSchedule
 */
export function isCampaignHourActive(campaignSchedule, dow, hour) {
    const schedule = campaignSchedule || [];
    const useSchedule = Array.isArray(schedule) && schedule.length > 0;
    if (!useSchedule) {
        return true;
    }
    const isoDay = dow + 1;
    for (const iv of schedule) {
        const day = iv.day;
        const startH = Math.floor(iv.startTime / 3600000);
        const endH = Math.floor(iv.endTime / 3600000);
        if (day === undefined || day === null) {
            if (hour >= startH && hour < endH) {
                return true;
            }
        } else if (day === isoDay) {
            if (hour >= startH && hour < endH) {
                return true;
            }
        }
    }
    return false;
}

/**
 * @param {Array<{day?: number, startTime: number, endTime: number}>|null|undefined} campaignSchedule
 * @returns {Array<{day_of_week: number, hour: number, min_interval_ms: number, max_per_minute: null}>}
 */
export function buildDefaultFrequencies(campaignSchedule) {
    const values = [];
    for (let dow = 0; dow <= 6; dow++) {
        for (let hour = 0; hour <= 23; hour++) {
            if (!isCampaignHourActive(campaignSchedule, dow, hour)) {
                continue;
            }
            const minutes = defaultMinutesForSlot(dow, hour);
            values.push({
                day_of_week: dow,
                hour,
                min_interval_ms: minutes * 60000,
                max_per_minute: null,
            });
        }
    }
    return values;
}
